// export const LANDING = "/";
export const SIGN_UP = "/signup";
export const SIGN_IN = "/signin";
export const SIGN_OUT = "/signout";
export const VERIFY_EMAIL = "/signup-complete";
export const CONTACT_US = "/contact-us";
export const HOME = "/";
export const ACCOUNT = "/account";
export const TERMS = "/terms";
export const INVITES = "/invites";
export const PRIVACY = "/privacy";
export const TRACKING = "/tracking";
export const CARE_PACKAGE = "/carepackage";
export const ADMIN = "/admin";
export const PASSWORD_FORGET = "/pw-forget";
export const UPDATE_PASSWORD = "/update-password";
export const SECRET_SANTA = [
  "/giftexchange",
  "/giftsexchange",
  "/gift-exchange",
  "/gifts-exchange",
  "/gifts_exchange",
  "/gift_exchange",
  "/gift",
  "/gifts",
  "/secretsanta",
  "/secret-santa",
  "/gifts/faq",
];
export const TEAM_GIFTS = ["/team-gifts", "/corporate-gifts", "/work-gifts"];
export const GIFTS = "/gifts";
export const LABEL = "/label";
export const CREATE = "/create";
export const LABELLIST = "/labellist";
export const DOWNLOAD = "/download";
export const DASHBOARD = "/dashboard";
export const ORDERS = "/orders";
export const MANIFESTS = "/manifests";
export const ADD_LABELS = "/add-labels";

export const ADDRESS_LIST = ACCOUNT + "/address-list";
export const ADDRESS_FORM = ACCOUNT + "/address-form";
export const CARD_LIST = ACCOUNT + "/card-list";

export const ACCOUNT_DETAILS = ACCOUNT + "/account-details";
export const API = ACCOUNT + "/api";

export const MORE_API = "/more/api";
export const MORE_SHOPIFY = "/more/shopify";
export const MORE_SHOP = "/more/shop-integrations";

export const ACCOUNT_FORMS = "/account-details";
export const UPDATE_ACCOUNT_DETAILS = ACCOUNT_FORMS + "/update-account-details";
export const BANK_ACCOUNT_DETAILS = ACCOUNT_FORMS + "/update-bank-details";
export const BUSINESS_REGISTRATION = ACCOUNT_FORMS + "/business-registration";
export const TAX_INFO = ACCOUNT_FORMS + "/tax-info";

export const HELP_CENTER = "/help-center";
export const WELCOME_TOUR = HELP_CENTER + "/welcome-tour";
export const PACKAGING_REQUIREMENTS = HELP_CENTER + "/packaging-requirements";
export const PICKUP_POINT_INFORMATION =
  HELP_CENTER + "/pickup-point-information";
export const ADMIN_SIGNIN = "/admin-signin";

export const INTRO = "/intro";
export const INTRO_FAQ = INTRO + "/faqs";

export const STORES = "/stores";
export const CHECKOUTS_DETAILS = STORES + "/details";
export const WHATSAPP_CONVERSATION = STORES + "/whatsapp";
export const CHECKOUTS_CREATE = CHECKOUTS_DETAILS + "/create";
export const CHECKOUTS_SETTINGS = CHECKOUTS_DETAILS + "/settings";
export const CHECKOUTS_PRODUCTS = CHECKOUTS_DETAILS + "/products";
export const CHECKOUTS_PRODUCTS_DETAIL = CHECKOUTS_PRODUCTS + "/detail";
export const CHECKOUTS_PRODUCTS_CREATE = CHECKOUTS_PRODUCTS + "/create";
export const SHOPIFY_CONNECT = STORES + "/shopify-connect";
export const SHOPIFY_CONNECT_ALT = STORES + "/shopify-connect-alternate";

export const CSV_IMPORT_PAGE = ORDERS + "/csv-import";

export const WALLETS = "/wallets";

export const KQ_LANDING = "/kq";
